import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import type { Manufacturer } from '../types';

const HEAD_COLOR: [number, number, number] = [90, 106, 207];
const ALT_COLOR: [number, number, number] = [245, 245, 245];

const MANUFACTURER_HEADERS = ['Nome Fantasia', 'Razão Social', 'CNPJ', 'Tipo'];

const manufacturerRows = (items: Manufacturer[]) =>
	items.map((m) => [
		m.tradingName ?? '-',
		m.businessName ?? '-',
		m.cnpj ?? '-',
		m.isPublic ? 'Público' : 'Privado',
	]);

export const exportManufacturersToExcel = (items: Manufacturer[]) => {
	const ws = XLSX.utils.aoa_to_sheet([MANUFACTURER_HEADERS, ...manufacturerRows(items)]);
	ws['!cols'] = [{ wch: 24 }, { wch: 24 }, { wch: 18 }, { wch: 10 }];
	const wb = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, ws, 'Fabricantes');
	XLSX.writeFile(wb, 'fabricantes.xlsx');
};

export const exportManufacturersToPdf = (items: Manufacturer[]) => {
	const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
	doc.setFontSize(16);
	doc.text('Fabricantes', 14, 15);
	autoTable(doc, {
		startY: 22,
		head: [MANUFACTURER_HEADERS],
		body: manufacturerRows(items),
		styles: { fontSize: 9, cellPadding: 2 },
		headStyles: { fillColor: HEAD_COLOR, textColor: 255, fontStyle: 'bold' },
		alternateRowStyles: { fillColor: ALT_COLOR },
	});
	doc.save('fabricantes.pdf');
};
